<template>
  <div>
    <b-button
      tag="a"
      type="is-light"
      class="has-text-primary"
      icon-left="shopping-outline"
      :href="click_destination"
      :loading="isBtnLoading"
      > <span v-if="isSynced">{{ order_total | currency }} <b>({{ item_count }})</b></span></b-button
    >
  </div>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import CartApi from "@/api/cart";

export default {
  name: "CartStatusBtn",
  mixins: [AppMappers, CartApi],
  props: ['click_destination'],
  data() {
    return { 
      isSynced: false,     
      isBtnLoading: false,
    };
  },    

  mounted() {
    this.sync()
  },
  methods: {
    sync() {
      let self = this;
      this.api_get('get_cart_status', response => {
        if(response) {
          self.fireCartChange({
            item_count: response.item_count,
            order_subtotal: response.order_subtotal,
            order_total: response.order_total,
          });
          self.isSynced = true;
        }
      });
    }
  },
  watch: {
    cart_status() {
      // this.sync()
    }
  }
};
</script>